module.exports = __webpack_public_path__ + "606db4fea96e442ee749740f80b378b4.jpg";